import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  arrangePromos,
  calculatePromotion,
  getApplicablePromotion,
} from "./usePriceCalculator";
import { getCalculatedTax } from "./utils";

const useOldPriceCalculator = () => {
  const [totalPrice, setTotalPrice] = useState(0);
  const [taxObj, setTaxObj] = useState({});
  const [totalTax, setTotalTax] = useState(0);
  const [totalGuests, setTotalGuests] = useState(0);
  const [totalAdults, setTotalAdults] = useState(0);
  const [totalInfants, setTotalInfants] = useState(0);
  const [totalChild, setTotalChild] = useState(0);
  const [roomObjects, setRoomObjects] = useState([]);
  const [totalRoomPrice, setTotalRoomPrice] = useState(0);
  const [totalFoodPrice, setTotalFoodPrice] = useState(0);
  const [totalAddonPrice, setTotalAddonPrice] = useState(0);
  const [arrangedPromos, setArrangedPromos] = useState([]);
  const [appliedDiscount, setAppliedDiscount] = useState({ discount: 0 });
  const [bulkDiscount, setBulkDiscount] = useState({});
  const [priceWODiscount, setPriceWODiscount] = useState(0);
  const [roomPriceNoDisc, setRoomPriceNoDisc] = useState(0);
  const [taxObjects, setTaxObjects] = useState({});
  const [couponValue, setCouponValue] = useState(0);

  const {
    selectedRooms,
    selectedHotelAddons,
    hotelData,
    promotions = [],
    selectedAddons,
    dateCount,
    totalAdult,
    roomSlots,
    taxes,
    couponCode = {},
    isHourlyRoom,
  } = useSelector((state) => state.hotelInfo);
  // console.log("sel", selectedRooms, totalAdult);
  useEffect(() => {
    const arrange = () => {
      let arr = [...promotions];
      let ar = arrangePromos(arr);
      setArrangedPromos(ar);
    };
    arrange();
  }, [
    promotions,
    selectedAddons,
    selectedHotelAddons,
    selectedRooms,
    totalAdult,
  ]);

  const checkForApplicableBulk = () => {
    if (!priceWODiscount) {
      return;
    }
    if (promotions?.length === 0 || !promotions) {
      return;
    }

    let filterArrays =
      promotions?.filter(
        (pr) => pr?.discountType === null && pr?.type === "bulk"
      ) || [];

    if (filterArrays?.length === 0 || !filterArrays) {
      return;
    }

    let sortedPromotions = [...filterArrays].sort((b, a) => {
      return Number(a?.discount) - Number(b?.discount);
    });

    for (let i = 0; i < sortedPromotions.length; i++) {
      let pr = sortedPromotions[i];
      if (Number(priceWODiscount) >= Number(pr?.cutoffAmount)) {
        let discount = priceWODiscount - (priceWODiscount * pr?.discount) / 100;
        if (discount < totalPrice + Math.abs(totalTax)) {
          let rms = [];
          let btax = 0;
          let rSum = 0,
            reduced = 0;
          let arr = [];
          [...roomObjects].forEach((rm) => {
            let sum = rm?.roomNoDisc;
            rSum += sum;

            reduced += (sum * pr?.discount) / 100;
            let afterDisc = sum - (sum * pr?.discount) / 100;

            const taxObj = getCalculatedTax({
              taxes: taxes,
              rooms: [{ id: rm?.id, amount: afterDisc }],
              isInclusive: hotelData?.isTaxIncluded,
              noOfNights: 1,
            });
            const taxAmnt = taxObj.totalRoomTax;
            btax += taxAmnt;
            arr.push({
              ...rm,
              sum: sum - reduced + taxAmnt,
              tax: btax,
              priceReduced: reduced,
              roomNoDisc: rm?.roomNoDisc,
            });
          });
          setRoomObjects(arr);
          setTotalTax(btax);
          setTotalRoomPrice(rSum - reduced);
          setAppliedDiscount({ discount: priceWODiscount - discount });
          setTotalPrice(discount + btax);
          setBulkDiscount(pr);
          return;
        } else if (discount === totalPrice + totalTax) {
          return;
        } else {
          setBulkDiscount({});
          return;
        }
      } else {
        setBulkDiscount({});
        return;
      }
    }

    if (selectedRooms?.length === 0) {
      setBulkDiscount({});
    }
  };

  useEffect(() => {
    checkForApplicableBulk();
  }, [promotions, priceWODiscount, taxObj, selectedRooms]);

  const calculatePrice = () => {
    let adults = 0,
      child = 0,
      infant = 0,
      price = 0,
      tax = 0,
      adnCost = 0,
      foodCost = 0,
      noDiscPrice = 0,
      couponDiscValue = 0,
      tempDisc = 0,
      rmArr = [];

    selectedRooms.forEach((room) => {
      const {
        pricing = [],
        priceConfig = {},
        chosenPriceConfig = "",
        priceConfigDifference = {},
      } = room;
      adults += room?.sAdult;
      child += room?.sChild;
      infant += room?.sInfant;
      let tempAdult = room?.sAdult,
        tempChild = room?.sChild,
        tempInfant = room?.sInfant,
        tempPrice = 0,
        priceReduced = 0,
        tempTax = 0,
        roomNoDisc = 0,
        promosApplied = [];

      pricing.forEach((pr, idx) => {
        let sum = 0;
        let couponPromo = {};
        let isDiffConfig = chosenPriceConfig === "priceConfigDifference";
        if (isDiffConfig && priceConfigDifference) {
          sum +=
            Number(pr?.price) + parseFloat(priceConfigDifference[tempAdult]);
          roomNoDisc +=
            Number(pr?.price) + parseFloat(priceConfigDifference[tempAdult]);
        } else {
          sum += Number(pr?.price) * parseFloat(priceConfig[tempAdult]);
          roomNoDisc += Number(pr?.price) * parseFloat(priceConfig[tempAdult]);
        }

        if (tempInfant && tempInfant > 0) {
          sum += room?.extraInfantPrice * tempInfant;
        }

        if (tempChild && tempChild > 0) {
          sum += room?.extraChildPrice * tempChild;
        }

        const promo = getApplicablePromotion({
          arrangedPromos,
          rp: { roomId: room?.id },
          tempPrice: sum,
          checkInDate: pr?.date,
        });

        let { finalValue, reducedPrice } = calculatePromotion({
          price: sum,
          promo,
          idx,
          dateCount,
        });

        if (couponCode?.id) {
          couponPromo = getApplicablePromotion({
            arrangedPromos: [couponCode],
            rp: { roomId: room?.id },
            tempPrice: couponPromo?.isStack ? finalValue : sum,
            checkInDate: pr?.date,
          });
          let couponCalc = calculatePromotion({
            price: couponPromo?.isStack ? finalValue : sum,
            promo: couponPromo,
            idx,
            dateCount,
          });
          couponDiscValue += couponCalc.reducedPrice;
          finalValue = couponCalc.finalValue;
          if (couponPromo?.isStack) {
            reducedPrice += couponCalc.reducedPrice;
          } else {
            reducedPrice = couponCalc.reducedPrice;
          }
        }

        if ((promo || couponPromo?.id) && !isHourlyRoom) {
          let arr = [];

          if (promo) {
            arr.push(promo);
          }

          if (couponPromo?.id) {
            if (couponPromo?.isStack) {
              arr.push(couponPromo);
            } else {
              arr = [couponPromo];
            }
          }

          promosApplied.push({
            promo: arr,
            checkInDate: pr?.date,
            reducedPrice,
          });
        }

        const taxObj = getCalculatedTax({
          taxes: taxes,
          rooms: [{ id: room?.id, amount: finalValue }],
          isInclusive: hotelData?.isTaxIncluded,
          noOfNights: 1,
        });

        const taxAmnt = taxObj.totalRoomTax;

        priceReduced += reducedPrice;

        tempPrice += finalValue + (!hotelData?.isTaxIncluded ? 0 : taxAmnt);
        tempTax += taxAmnt;

        if (isHourlyRoom) {
          let slotObj = roomSlots[room?.id];
          let defaultPrice = 0;
          if (isDiffConfig && priceConfigDifference) {
            defaultPrice =
              Number(pr?.price) +
              parseFloat(priceConfigDifference[room?.defaultGuestCount]);
          } else {
            defaultPrice =
              Number(pr?.price) *
              parseFloat(priceConfig[room?.defaultGuestCount]);
          }

          if (tempAdult <= room?.defaultGuestCount) {
            tempPrice = defaultPrice * slotObj?.percentage;
          } else {
            if (isDiffConfig && priceConfigDifference) {
              tempPrice =
                defaultPrice * slotObj?.percentage +
                priceConfigDifference[room?.sAdult];
            } else {
              tempPrice =
                defaultPrice * slotObj?.percentage +
                (priceConfig[room?.sAdult] * defaultPrice - defaultPrice);
            }
          }
          priceReduced = 0;
          roomNoDisc = tempPrice;
          tempTax = 0;
        }
      });
      noDiscPrice += roomNoDisc;

      let rmObj = {
        ...room,
        sum: tempPrice,
        tax: tempTax,
        priceReduced,
        roomNoDisc,
        promosApplied: [...new Set(promosApplied)],
      };
      rmArr.push(rmObj);
      price += tempPrice;
      tax += tempTax;
      tempDisc += priceReduced;
    });

    // if (hotelData?.currency !== "INR") {
    //   price += tax;
    //   tax = 0;
    // }

    setAppliedDiscount({ discount: tempDisc });
    setTotalGuests(adults + child + infant);
    setTotalAdults(adults);
    setTotalChild(child);
    setTotalInfants(infant);
    setCouponValue(couponDiscValue);
    setTotalRoomPrice(price);
    setTotalTax(tax);
    setRoomObjects(rmArr);
    setRoomPriceNoDisc(noDiscPrice);

    selectedAddons?.forEach((addon) => {
      foodCost = foodCost + parseFloat(addon?.price) * dateCount;
    });

    setTotalFoodPrice(foodCost);

    selectedHotelAddons?.forEach((adn) => {
      if (adn.Addon.multiplier === "per_day") {
        adnCost += parseFloat(adn.price) * dateCount;
      } else {
        adnCost += parseFloat(adn.price);
      }
    });

    setTotalAddonPrice(adnCost);

    price = price + adnCost + foodCost;

    setTotalPrice(price);
    setPriceWODiscount(noDiscPrice + adnCost + foodCost);
  };

  useEffect(() => {
    calculatePrice();
  }, [
    selectedRooms,
    selectedAddons,
    roomSlots,
    selectedHotelAddons,
    arrangedPromos,
    isHourlyRoom,
    couponCode,
    promotions,
  ]);

  useEffect(() => {
    const calculateTax = () => {
      let arr = [...roomObjects];
      let newArr = arr.map((ro) => ({ id: ro?.id, amount: ro?.sum + ro?.tax }));

      let txObj = getCalculatedTax({
        rooms: newArr,
        taxes: taxes,
        isInclusive: hotelData?.isTaxIncluded,
        noOfNights: dateCount,
      });
      // setTotalTax(txObj.totalRoomTax);
      setTaxObj(txObj);
    };
    roomObjects.length > 0 && calculateTax();
  }, [roomObjects, taxes]);

  return {
    totalPrice,
    totalGuests,
    roomObjects,
    totalRoomPrice,
    totalTax,
    totalAddonPrice,
    totalFoodPrice,
    totalAdults,
    totalChild,
    appliedDiscount,
    totalInfants,
    roomPriceNoDisc,
    couponValue,
    bulkDiscount,
    taxObj,
  };
};

export default useOldPriceCalculator;
